import React, { useState } from 'react';
import { ZoomIn } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';

/**
 * Изображение в статье блога: клик открывает увеличенный просмотр.
 */
export function BlogZoomableImage({ src, alt, className = '', loading = 'lazy' }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`group relative block w-full cursor-zoom-in rounded-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 ${className}`}
        aria-label={`Увеличить изображение: ${alt}`}
      >
        <img
          src={src}
          alt={alt}
          className="w-full rounded-xl shadow-lg pointer-events-none"
          loading={loading}
        />
        <span
          className="absolute inset-0 flex items-center justify-center rounded-xl bg-black/0 transition-colors group-hover:bg-black/25"
          aria-hidden
        >
          <span className="flex items-center gap-2 rounded-lg bg-black/65 px-3 py-2 text-sm text-white opacity-0 transition-opacity group-hover:opacity-100">
            <ZoomIn className="h-4 w-4" />
            Увеличить
          </span>
        </span>
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          className="max-h-[96vh] max-w-[min(96vw,1200px)] border-0 bg-transparent p-2 shadow-none sm:p-4 [&>button]:rounded-full [&>button]:bg-black/60 [&>button]:text-white [&>button]:hover:bg-black/80"
          onClick={(e) => e.stopPropagation()}
        >
          <DialogTitle className="sr-only">{alt}</DialogTitle>
          <img
            src={src}
            alt={alt}
            className="mx-auto max-h-[85vh] w-auto max-w-full rounded-lg object-contain"
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default BlogZoomableImage;
